// import React from "react";
// import { Box, Dialog, Modal } from "@mui/material";

// import { TailSpin, Triangle } from "react-loader-spinner";
// import { useAppStore } from "../appStore";

// function Loader() {
//   const { loading } = useAppStore();

//   const style = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//   };
//   return (
//     <Modal open={loading} sx={{ background: "transparent" }}>
//       <Box sx={style}>
//         <TailSpin
//           color="#2196f3"
//           visible={true}
//           height="80"
//           width="80"
//           strokeWidth={4}
//         />
//       </Box>
//     </Modal>
//   );
// }

// export default Loader;
import React from "react";
import { Box } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import { useAppStore } from "../appStore";

function Loader({ overlay = true }) {
  const { loading } = useAppStore();

  if (!loading) return null;

  return overlay ? (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.6)", // semi-transparent
        zIndex: 2,
      }}
    >
      <TailSpin color="#2196f3" height="80" width="80" strokeWidth={4} />
    </Box>
  ) : (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <TailSpin color="#2196f3" height="80" width="80" strokeWidth={4} />
    </Box>
  );
}

export default Loader;
